import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.error('Supabase public config is missing. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY before building.');
}

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    })
  : null;

export const testSupabaseConnection = async () => {
  if (!supabase) {
    return {
      success: false,
      error: new Error('Supabase public config is missing.'),
    };
  }

  try {
    const { data, error } = await supabase
      .from('users')
      .select('id')
      .limit(1);

    if (error) {
      console.error('Supabase connection test failed:', error);
      return { success: false, error };
    }

    console.log('Supabase connection is healthy.');
    return { success: true, data };
  } catch (err) {
    console.error('Supabase connection test threw:', err);
    return { success: false, error: err };
  }
};
